module.exports = __webpack_public_path__ + "static/Roboto-BlackItalic-18a576bf7ceb253929ac1f7bdfe6d467.ttf";